import { ThreesomeStatus } from '@bells/schema/models/attendant';
import { RequestForm } from '@bells/schema/models/request';
import { createContext, useContext } from 'react';

export type RequestContextProps = {
  values: Partial<
    Omit<RequestForm, 'startDate'> & {
      startDate: (Date | string)[];
    }
  >;
  setValues: (
    val: Partial<
      Omit<RequestForm, 'startDate'> & {
        startDate: (Date | string)[];
      }
    >
  ) => void;
  totalPrice?: number;
  travelCosts?: number;
  distance?: string;
  isLoadingCalculate: boolean;
  service?: ThreesomeStatus;
  dataDuration: {
    price: number;
    hour: number;
  }[];
};

export const RequestContext = createContext<RequestContextProps>({
  values: {},
  setValues: () => {},
  isLoadingCalculate: false,
  dataDuration: [],
});

export const useRequest = (): RequestContextProps => {
  return useContext(RequestContext);
};
